export enum TaskStatusCategory {
    ACTIVE = 'Active',
    COMPLETED = 'Completed',
    CANCELED = 'Canceled',
}

export enum TaskStatusSystemKey {
    BACKLOG = 'backlog',
    TODO = 'todo',
    IN_PROGRESS = 'in_progress',
    IN_REVIEW = 'in_review',
    BLOCKED = 'blocked',
    COMPLETED = 'completed',
    CANCELED = 'canceled',
}

export interface TaskStatus {
    id: string;
    name: string;
    systemKey?: TaskStatusSystemKey | null;
    category: TaskStatusCategory;
    color: string;
    position: number;
    isDefault: boolean;
    createdAt: Date;
    updatedAt: Date;
}
